// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.fi-page-collapsable-content {
  display: block;
}
.fi-page-collapsable-content.toggle-icon-position-right .fi-page-collapsable-content-title-toggle-block-icon {
  float: right;
}

.fi-page-collapsable-content-clicable {
  cursor: pointer;
}

fi-page-collapsable-content-subtitle {
  display: block;
  font-size: smaller;
}

.fi-page-collapsable-content-title-toggle-block-icon {
  display: inline-block;
  margin-bottom: 3px;
  transition: transform 130ms ease-out;
  color: var(--fi-color-dark);
  font-size: 16px;
}
.fi-page-collapsable-content-title-toggle-block-icon.closed {
  transform: rotate(0deg);
}
.fi-page-collapsable-content-title-toggle-block-icon.opened {
  transform: rotate(180deg);
}

fi-page-collapsable-content-title {
  font-weight: bold;
}`, "",{"version":3,"sources":["webpack://./Source/app/components/fi-page-collapsable-content/fi-page-collapsable-content.component.scss"],"names":[],"mappings":"AAAA;EACI,cAAA;AACJ;AAEQ;EACI,YAAA;AAAZ;;AAQA;EACI,eAAA;AALJ;;AAQA;EACI,cAAA;EACA,kBAAA;AALJ;;AAQA;EACI,qBAAA;EACA,kBAAA;EACA,oCAAA;EACA,2BAAA;EACA,eAAA;AALJ;AAOI;EACI,uBAAA;AALR;AAQI;EACI,yBAAA;AANR;;AAUA;EACI,iBAAA;AAPJ","sourcesContent":[".fi-page-collapsable-content {\r\n    display: block;\r\n\r\n    &.toggle-icon-position-right {\r\n        .fi-page-collapsable-content-title-toggle-block-icon {\r\n            float: right;\r\n        }\r\n    }\r\n}\r\n\r\n.fi-page-collapsable-content-visible {\r\n}\r\n\r\n.fi-page-collapsable-content-clicable {\r\n    cursor: pointer;\r\n}\r\n\r\nfi-page-collapsable-content-subtitle {\r\n    display: block;\r\n    font-size: smaller;\r\n}\r\n\r\n.fi-page-collapsable-content-title-toggle-block-icon {\r\n    display: inline-block;\r\n    margin-bottom: 3px;\r\n    transition: transform 130ms ease-out;\r\n    color: var(--fi-color-dark);\r\n    font-size: 16px;\r\n\r\n    &.closed {\r\n        transform: rotate(0deg);\r\n    }\r\n\r\n    &.opened {\r\n        transform: rotate(180deg);\r\n    }\r\n}\r\n\r\nfi-page-collapsable-content-title {\r\n    font-weight: bold;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
